
/**
 * Show a modal to request notification permission using the theme's popup system
 */
export async function showNotificationPermissionModal(onAccept) {
	if (typeof wpcore.showPopup !== 'function') {
		return;
	}

	wpcore.showPopup('fcm-permission');

	const acceptBtn = document.getElementById('fcm-modal-accept');
	if (acceptBtn) {
		acceptBtn.onclick = () => {
			if (typeof wpcore.closePopup === 'function') {
				wpcore.closePopup('fcm-permission');
			}
			if (typeof onAccept === 'function') onAccept();
		};
	}
}

/**
 * Show a modal with instructions to fix Brave/Firefox push service error
 */
export function showPushServiceErrorInstructions() {
	if (typeof wpcore.showPopup !== 'function') {
		return;
	}

	const isBrave = navigator.brave && typeof navigator.brave.isBrave === 'function';
	const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');

	// Reset displays
	const braveDiv = document.getElementById('fcm-error-brave');
	const firefoxDiv = document.getElementById('fcm-error-firefox');
	const genericDiv = document.getElementById('fcm-error-generic');

	if (braveDiv) braveDiv.classList.add('hidden');
	if (firefoxDiv) firefoxDiv.classList.add('hidden');
	if (genericDiv) genericDiv.classList.add('hidden');

	// Toggle correct instruction based on browser
	if (isBrave && braveDiv) {
		braveDiv.classList.remove('hidden');
	} else if (isFirefox && firefoxDiv) {
		firefoxDiv.classList.remove('hidden');
	} else if (genericDiv) {
		genericDiv.classList.remove('hidden');
	}

	// Show theme popup
	wpcore.showPopup('fcm-error');
}
